import { requestWithToken } from "../apiConfigs/request";

export const fetchBusinessTypes = () => {
  return requestWithToken({
    url: `/static/business_unit_type`,
    method: 'GET',
  });
}